import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useState, useEffect } from 'react';
import {
    TextField,
    Grid2,
    Modal,
} from "@mui/material";
import './Login.css';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastError, ToastSuccess } from '../../../CustomToaster/CustomToaster';
import { updateOtpTime } from '../../../Actions/AuthAction';
import { resendOtp, VerifyOtp } from '../../../Services/auth';
import { InputError } from '../../Errors/ErrorText';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { updateAuthStatus } from '../../../Actions/AuthAction';
import lightLogo from '../../../Images/fouchain-logo-light.svg';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'var(--color-BasicBg)',
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
};


const Verify = () => {
    //custom code
    const navigate = useNavigate();
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const location = useLocation();

    const [pop7, setpop7] = useState(false);

    const handlePopOpen7 = async () => {
        setpop7(true);
    };

    const handlePopClose7 = async () => {
        setpop7(false);
    };

    const [timeExpired, setTimerExpired] = useState(false);
    const { time } = useSelector((state) => state.auth);
    const [targetTime, setTargetTime] = useState(time);
    const [enableOtp, setEnableOtp] = useState(true);
    const [email, setEmail] = useState("");

    const [errors, setErrors] = useState({
        otp: "",
        email: "",
    });

    const inputRefs = React.useRef([]);

    const [load, setLoad] = useState(false);
    const [block, setBlock] = useState(false);

    useEffect(() => {
        if (time) {
            setTargetTime(time)
        }
    }, [time]);


    useEffect(() => {
        if (!location?.state?.data?.email) {
            navigate("/login");
        }
        // handlePopOpen7();

    }, []);

    useEffect(() => {
        if (location?.state?.data?.email) {
            if (location?.state?.data?.blocked) {
                setBlock(true);
                handlePopOpen7();
                setTargetTime(location?.state?.data?.time);
            } else {
                setEmail(location?.state?.data?.email);
                setEnableOtp(true);
            }
        }
        setTargetTime(time);
    }, []);

    const handleInputChange = (value, index) => {
        if (isNaN(value)) return;
        setErrors({
            ...errors,
            otp: "",
        });

        const updatedOtp = [...otp];
        updatedOtp[index] = value;
        setOtp(updatedOtp);

        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData("text");
        if (!new RegExp(`^[0-9]{${otp.length}}$`).test(text)) {
            return;
        }
        const digits = text.split("");
        setOtp(digits);
    };

    const handleResend = async () => {
        const data = {
            type: "email",
            value: email,
            verifyType: location?.state?.type ? location?.state?.type : "Verify-Login",
        };
        setLoad(true);
        const response = await resendOtp(data);
        if (response?.data?.success === true) {
            setOtp(new Array(6).fill(""));
            dispatch(updateOtpTime(response?.data?.result?.time));
            ToastSuccess({ message: response?.data?.message, icon: false });

            setTargetTime(response?.data?.result?.time);
            setTimerExpired(false);
            setEnableOtp(true);
            setErrors({ otp: "" })
            setLoad(false);
        } else {
            if (response?.data?.result?.blocked === true) {
                dispatch(updateOtpTime(response?.data?.result?.time));
                setBlock(true);
                handlePopOpen7();
                setTargetTime(response?.data?.result?.time);
            } else {
                ToastError({ message: response?.data?.message, icon: false });
            }
            setLoad(false);
        }
    };

    const CountdownTimer = ({ timestamp, setTimerExpired }) => {
        const location = useLocation();

        const targetTimestamp = timestamp || time || location?.state?.data?.time;

        useEffect(() => {
            if (!targetTimestamp) {
                // navigate("/");
            }
        }, [targetTimestamp]);

        // Calculate remaining time in seconds
        const calculateRemainingTime = () => {
            const now = Date.now();
            return Math.max(Math.floor((targetTimestamp - now) / 1000), 0);
        };

        const [count, setCount] = useState(calculateRemainingTime());

        useEffect(() => {
            // Stop when countdown reaches 0
            if (count <= 0) {
                setTimerExpired(true);
                return;
            }

            const interval = setInterval(() => {
                setCount(calculateRemainingTime()); // Update countdown
            }, 1000);

            return () => clearInterval(interval); // Cleanup
        }, [count]);

        // Format time as MM:SS
        const formatTime = (seconds) => {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${String(minutes).padStart(2, "0")}m:${String(secs).padStart(
                2,
                "0"
            )}s`;
        };

        return <p className="timer">{formatTime(count)}</p>;
    };

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const validate = () => {
        let formErrors = {};
        let isValid = true;
        const otpValues = otp.join("");

        if (enableOtp === false) {
            if (!allUsers.email) {
                formErrors.email = "Email is required";
                isValid = false;
            } else if (!emailRegex.test(allUsers.email)) {
                formErrors.email = "Email is invalid";
                isValid = false;
            }
        } else {
            if (otpValues.length !== 6) {
                formErrors.otp = "OTP cannot be empty";
                isValid = false;
            }
        }

        setErrors(formErrors);
        return isValid;
    };

    const [allUsers, setAllUsers] = useState({});

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setAllUsers({ ...allUsers, [name]: value });
    };
    const validateFocus = (e) => {
        const fieldName = e?.target?.name;
        const fieldValue = e?.target?.value;
        const value = fieldValue.trim();

        let isValid = true;
        let errorMessage = "";

        if (fieldName === "email") {
            if (value === "" || value === undefined) {
            } else if (!emailRegex.test(fieldValue)) {
                errorMessage = "Email is invalid";
                isValid = false;
            }
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: errorMessage,
        }));

        return isValid;
    };

    const handleEmailSubmit = async () => {
        if (validate()) {
            const data = {
                type: "email",
                value: allUsers.email,
                // 'email': allUsers.email,
            };
            setLoad(true);
            const response = await resendOtp(data);
            if (response?.data?.success === true) {
                ToastSuccess({ message: response?.data?.message, icon: false });

                setTargetTime(response?.data?.result?.time);
                setEmail(response?.data?.result?.email);
                setTimerExpired(false);
                setEnableOtp(true);
                setLoad(false);
            } else {
                ToastError({ message: response?.data?.message, icon: false });

                setLoad(false);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            const otpString = otp?.join("").trim();

            // Check if OTP is empty, contains spaces, or not numeric
            if (!otpString || otpString.length < 6 || !/^\d{6}$/.test(otpString)) {
                setErrors((prev) => ({
                    ...prev,
                    otp: "Please enter a valid 6-digit OTP",
                }));
                setLoad(false);

                return;
            }

            const data = {
                type: "email",
                value: email,
                OTP: otpString,
                verifyType: location?.state?.type ? location?.state?.type : "register",
            };
            setLoad(true);
            const response = await VerifyOtp(data);
            if (response?.data?.success === true) {
                ToastSuccess({ message: response?.data?.message, icon: false });

                if (response?.data?.result?.type === "forgotpassword") {
                    navigate("/reset", {
                        replace: true,
                        state: { email: response?.data?.result?.email, verify: true },
                    });
                } else {
                    const result = response?.data?.result;

                    if (result?.accessToken) {
                        localStorage.setItem("token", result.accessToken);
                    }

                    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
                    userData.emailVerify = 1;
                    userData.isAuthenticated = true;
                    localStorage.setItem("userData", JSON.stringify(userData));

                    dispatch(updateAuthStatus(response?.data?.result?.token));


                    navigate("/portfolio", { replace: true });
                }


                setLoad(false);
            } else {
                ToastError({ message: response?.data?.message, icon: false });

                setLoad(false);
            }
        }
    };

    const dispatch = useDispatch();


    return (
        <div className='auth-page login-page'>
            <Box
                component="main"
                className='login-card login-card2'
            >


                <Link to={'/'}>
                    <div className="logo">
                        <img width={120} src={lightLogo} alt="logo" />
                    </div>
                </Link>
                <Stack sx={{ gap: 4, mb: 2 }}>
                    <Stack sx={{ gap: 1 }}>
                        <Typography component="h1" sx={{ fontSize: '35px', textAlign: 'center' }}>
                            OTP Verification
                        </Typography>
                        <Typography level="body-sm" sx={{ fontSize: '16px', textAlign: 'center' }}>
                            {/* Enter your one time password  to access */}
                        </Typography>
                    </Stack>

                </Stack>

                {/* <form onSubmit={handleSubmit}> */}
                <Grid2 container spacing={2}>
                    {
                        !enableOtp ?
                            <>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <FormControl fullWidth required>
                                        <div className='input-common OtpInput-number-main text-center'>
                                            <FormLabel>Your email address</FormLabel>
                                            <div style={{ marginTop: '20px' }}>
                                                <TextField
                                                    name="email"
                                                    type="email"
                                                    inputProps={{ maxLength: 40 }}
                                                    value={allUsers.email}
                                                    onChange={(e) => handleChange(e)}
                                                    onInput={validateFocus}
                                                    error={!!errors.email}
                                                    helperText={errors.email}
                                                />
                                            </div>
                                        </div>
                                    </FormControl>
                                </Grid2>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Stack spacing={2} mt={2}>
                                        <div className='but-one text-center'>
                                            <Button type="submit" variant="contained" fullWidth
                                                onClick={(e) => {
                                                    handleEmailSubmit(e);
                                                }}
                                                disabled={load === true}
                                            >
                                                Continue
                                            </Button>
                                        </div>
                                    </Stack>
                                </Grid2>
                            </>
                            :
                            <>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <FormControl fullWidth required>
                                        <div className='input-common OtpInput-number-main text-center'>
                                            <FormLabel>Enter OTP</FormLabel>
                                            <div style={{ marginTop: '20px' }}>
                                                <div className='input-common OtpInput-number-main mt-30' style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 20 }}>

                                                    {otp.map((value, index) => (
                                                        <TextField
                                                            key={index}
                                                            inputRef={(el) => (inputRefs.current[index] = el)}
                                                            value={value}
                                                            onChange={(e) => handleInputChange(e.target.value, index)}
                                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                                            onPaste={handlePaste}
                                                            inputProps={{
                                                                maxLength: 1,
                                                                style: {
                                                                    textAlign: "center",
                                                                    fontSize: "20px",
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    borderRadius: "4px",
                                                                    background: "transparent",
                                                                    color: "var(--color-PrimaryText)",
                                                                    caretColor: "var(--color-PrimaryText)",

                                                                },
                                                            }}
                                                            variant="outlined"
                                                            sx={{
                                                                "& input": {
                                                                    color: "var(--color-PrimaryText)",
                                                                    padding: "10px",
                                                                    caretColor: "var(--color-PrimaryText)",
                                                                },
                                                            }}
                                                            autoFocus={index === 0}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </FormControl>
                                </Grid2>

                                {block === false && (
                                    <Grid2 item size={{ xs: 12 }} textAlign="center" className="input-common">
                                        <div style={{ textAlign: 'center' }}><InputError error={errors?.otp} /></div>
                                        {timeExpired ? (
                                            <div className='but-one mt-30'>
                                                <Button
                                                    onClick={handleResend}
                                                    variant="outlined"
                                                    color="primary"
                                                    sx={{ mt: 3 }}
                                                    className="resend-btn"
                                                    disabled={load === true}
                                                >
                                                    Resend OTP
                                                </Button>
                                            </div>
                                        ) : (
                                            <CountdownTimer setTimerExpired={setTimerExpired} timestamp={targetTime} />
                                        )}
                                    </Grid2>
                                )}

                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Stack spacing={2} mt={2}>
                                        <div className='but-one text-center'>
                                            {
                                                load === true ?
                                                    <Button type="submit" variant="contained" fullWidth disabled>
                                                        Progressing
                                                    </Button>

                                                    :
                                                    <Button type="submit" variant="contained" fullWidth onClick={(e) => {
                                                        if (block === true) {
                                                            handlePopOpen7();
                                                        } else {
                                                            handleSubmit(e);
                                                        }
                                                    }}>
                                                        Verify
                                                    </Button>
                                            }
                                        </div>
                                    </Stack>
                                </Grid2>
                            </>

                    }

                </Grid2>
                {/* </form> */}
                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography className='mt-20' level="body-sm" sx={{ textAlign: "center" }}>
                        <span className="cta">
                            <Link
                                to="/login"
                                className="hover-underline-animation gold-color"
                                level="title-sm"
                                sx={{
                                    textDecoration: "none",
                                    paddingLeft: "5px",
                                    color: "#fff",
                                    fontSize: "14px",
                                }}
                            >
                                {" "}
                                Click here to   Sign in.
                            </Link>
                        </span>
                    </Typography>
                </Grid2>


                <div className="modal-popup text-center">
                    <Modal open={pop7} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                        <Box sx={style}>
                            <div className="display-2">
                                <h2>OTP Verification</h2>
                                <CancelRoundedIcon onClick={() => { handlePopClose7(); }} sx={{ color: "#3665FF", fontSize: "30px", cursor: "pointer" }} />
                            </div>

                            <div className="assistant-cnt">
                                <Grid2
                                    container
                                    justifyContent="center"
                                    spacing={2}
                                    sx={{ mt: 2 }}
                                >
                                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <div className="display-1 mt-20" style={{ justifyContent: "center" }} >
                                            <div className="text-center">
                                                <p>
                                                    You’ve reached the maximum number of OTP attempts.
                                                    Your account is blocked for{" "}
                                                    <CountdownTimer
                                                        setTimerExpired={setTimerExpired}
                                                        timestamp={targetTime}
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </Grid2>
                                </Grid2>
                            </div>

                            <Stack
                                direction="row"
                                spacing={2}
                                sx={{ justifyContent: "center" }}
                                className="mt-20 assitant-stack"
                            ></Stack>
                        </Box>
                    </Modal>
                </div>

            </Box>

        </div>
    )
}

export default Verify
